import { Add, Close } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  MenuItem,
  Rating,
  TextField,
} from "@mui/material";
import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { headers } from "..";
import MkxInput from "react-mkx-components";
import { privateAxiosIntance } from "../../../Config/axios";

const ManageTestimonials = ({ selected, setSelected, refetch }) => {
  const [open, setOpen] = useState(false);
  const [clients, setClients] = useState([]);

  const clientsFn = async () => {
    try {
      const response = await privateAxiosIntance.get("/client-api/");
      setClients(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    clientsFn();
  }, []);

  const addTestimonialsFn = async (reqbody) => {
    try {
      const response = await privateAxiosIntance.post(
        "/client-feedback-api/",
        reqbody,
      );
      toast.success(response.data.message);
      refetch();
      formik.resetForm();
      setOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  const updateTestimonialsFn = async (reqbody) => {
    try {
      const response = await privateAxiosIntance.put(
        "/client-feedback-api/",
        reqbody,
      );
      toast.success(response.data.message);
      refetch();
      setSelected(null);
      formik.resetForm();
      setOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      client_id: clients?.find((i) => i.name === selected?.client)?.id ?? "",
      comment: selected?.comment ?? "",
      url: selected?.url ?? "",
      feedback: selected?.feedback ?? 0,
    },
    onSubmit: (values) => {
      const payload = {
        ...values,
        feedback: values.feedback ?? 0, // safety
      };

      selected
        ? updateTestimonialsFn({
            ...payload,
            client_feedback_id: selected.id,
          })
        : addTestimonialsFn(payload);
    },
  });

  const handleClose = () => {
    setOpen(false);
    setSelected(null);
    formik.resetForm();
  };

  return (
    <>
      <Button
        startIcon={<Add />}
        variant="outlined"
        onClick={() => setOpen(true)}
      >
        Testimonial
      </Button>

      <Dialog
        open={Boolean(open || selected)}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle className="flex items-center justify-between !p-2">
          <p className="font-semibold">Testimonial</p>
          <IconButton size="small" onClick={handleClose}>
            <Close />
          </IconButton>
        </DialogTitle>

        <Divider />

        <form onSubmit={formik.handleSubmit}>
          <DialogContent className="flex flex-col gap-2">
            {/* Rating */}
            <div className="flex justify-center py-2">
              <Rating
                name="feedback"
                value={formik.values.feedback}
                onChange={(_, newValue) =>
                  formik.setFieldValue("feedback", newValue ?? 0)
                }
              />
            </div>

            {/* Client */}
            <TextField
              select
              margin="dense"
              label="Client"
              size="small"
              fullWidth
              name="client_id"
              value={formik.values.client_id}
              onChange={formik.handleChange}
            >
              {clients?.map((i) => (
                <MenuItem key={i.id} value={i.id}>
                  {i.name}
                </MenuItem>
              ))}
            </TextField>

            {/* Video URL */}
            {/* <MkxInput
              margin="dense"
              size="small"
              name="url"
              fullWidth
              label="Video URL (optional)"
              formik={formik}
            /> */}

            {/* Comment */}
            <TextField
              margin="dense"
              label="Video URL (optional)"
              fullWidth
              size="small"
              name="url"
              value={formik.values.url}
              onChange={formik.handleChange}
            />

            {/* Comment */}
            <TextField
              margin="dense"
              label="Comment"
              fullWidth
              multiline
              rows={4}
              size="small"
              name="comment"
              value={formik.values.comment}
              onChange={formik.handleChange}
            />

            {/* Actions */}
            <DialogActions className="!px-0">
              <Button onClick={handleClose} variant="contained" color="inherit">
                Cancel
              </Button>
              <Button type="submit" variant="contained" color="primary">
                Submit
              </Button>
            </DialogActions>
          </DialogContent>
        </form>
      </Dialog>
    </>
  );
};

export default ManageTestimonials;
